import { SignUp } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { gradient } from '../ad/theme';

export const Route = createFileRoute('/sign-up')({
  component: SignUpPage,
});

function SignUpPage() {
  // Sit the signed-out screen on the same dark teal-mint page background as the
  // app shell so there is NO flash of a white card on a dark page (K4 gotcha).
  return (
    <main
      className="flex min-h-svh items-center justify-center p-8"
      style={{ background: gradient.pageBg }}
    >
      <SignUp />
    </main>
  );
}
